// Mirrors _features/plans/state/slice.js's shape (selectedFilters +
// customColumns, REHYDRATE normalization) - does NOT carry forward the old
// features/ProductsFeature/slice.js's `products` mirror (write-only
// dead-sync - nothing outside ProductsFeature ever read
// state.productsFeature.products; useProductData already returns straight
// from the RTK Query cache).
//
// Same store key (`productsFeature`) the old slice used, but the field
// name modernizes from `selectedProductsFilters` to `selectedFilters`
// (matching every other migrated feature's slice shape) - persisted state
// under the old field name is simply reset to default on redeploy, same
// one-time abandonment already accepted for Plans' key rename.
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const initialState = {
  selectedFilters: {
    sort: "-createdAt",
  },
};

const productsFeatureSlice = createSlice({
  name: "productsFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: "-createdAt",
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.productsFeature) {
        const persistedData = action.payload.productsFeature;
        const persistedSort = persistedData.selectedFilters?.sort;

        return {
          ...state,
          ...persistedData,
          selectedFilters: {
            ...persistedData.selectedFilters,
            sort: persistedSort || "-createdAt",
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } =
  productsFeatureSlice.actions;

export default productsFeatureSlice.reducer;
